import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { updateCompanySalesStatus } from "../../services/SalesServices";
import {
  getCommonSearchList,
  getSettingsCompanyDetails,
} from "../../services/settingsServices";
import { getCompanyEcommerceHashList } from "../../services/CompanyEcommerceHashService";
import moment from "moment";
import ReactPaginate from "react-paginate";
import {
  AddReservesConvertToSales,
  cancelReservesData,
  getMainReservesList,
  getParentWarhouseData,
  getReservesDetails,
  getwarHouseEntityList,
} from "../../services/PartsInventory";
import {
  getSerachClientProfile,
  getSerachUserProfile,
} from "../../services/ClientProfileServices";
import { getDocumentSetList } from "../../services/MoloniServices";

const statusMap = {
  1: { label: "ACTIVE", className: "badge bg-success" },
  2: { label: "CANCELED", className: "badge bg-danger" },
  3: { label: "CONVERTED INTO SALE", className: "badge bg-primary" },
};

const statusList = [
  { value: 1, label: "ACTIVE" },
  { value: 2, label: "CANCELED" },
  { value: 3, label: "CONVERTED INTO SALE" },
];

const covertSalesList = [
  { value: 1, label: "Internal" },
  { value: 2, label: "Marketplace" },
];

const ReservesList = () => {
  const location = useLocation();
  const RolePermission = Utils.getRecordForCurrentPath(location);
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    reservation_status: 1,
    warehouse_id: "",
    search_client: "",
  });

  const [clientFilterData, setClientFilterData] = useState({
    reservation_status: "",
    search_client: "",
    warehouse_id: "",
  });

  const [totalRecords, setTotalRecords] = useState(0);

  const [reservesList, setReservesList] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");

  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [salesViewData, setSalesViewData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [statusResList, setStatusResList] = useState([]);
  const [companyEcommerceList, setCompanyEcommerceList] = useState([]);
  const [salesData, setSalesData] = useState({
    order_status: "",
  });
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  let errorsObj = {
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [failedData, setFailedData] = useState({
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
  });

  let errorsObjRefund = {
    refund_value: "",
    refund_type: "",
    refund_reason: "",
  };
  const [errorsRefund, setErrorsRefund] = useState(errorsObjRefund);

  const [refundData, setRefundData] = useState({
    refund_value: "",
    refund_type: "",
    refund_reason: "",
  });

  const [modifyAcceptedModal, setModifyAcceptedModal] = useState(false);
  const [modifyCancelModal, setModifyCancelModal] = useState(false);
  const [modifyRefundModal, setModifyRefundModal] = useState(false);
  const [refundTypeList, setRefundTypeList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [show, setShow] = useState(false);
  const [entityList, setEntityList] = useState([]);
  const [userDataMainList, setUserDataMainList] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [modifyconverToSales, setModifyconverToSales] = useState(false);
  const [converToSalesDataList, setConverToSalesDataList] = useState("");
  const [converToSalesData, setConverToSalesData] = useState({
    reservation_id: "",
    warehouses_id: "",
    seller_id: companyId?.id ? companyId?.id : "",
    sales_type: 1,
    sales_notes: "",
    client_id: "",
    shipping_price: "",
    packing_price: "",
    parcel_price: "",
    expiration_date: "",
    document_set_id: "",
  });

  const [modifyClientModal, setModifyClientModal] = useState(false);
  const [clientProfileData, setclientProfileData] = useState({
    uuid: "",
    id: "",
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [""],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: 23,
    is_vat_exempt: "0",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
    country_code: "",
  });

  const [modifyClientDetailsModal, setModifyClientDetailsModal] =
    useState(false);
  const [clientResDataDetails, setClientResDataDetails] = useState("");
  const [reserveDetails, setReserveDetails] = useState([]);
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [documentSetList, setDocumentSetList] = useState([]);

  const handleClientDetailsOpen = (e, item) => {
    setClientResDataDetails(item);
    setModifyClientDetailsModal(true);
  };

  const handleClientDetailsClose = (e) => {
    setModifyClientDetailsModal(false);
  };

  const handleConvertToSaleOpen = (e, item) => {
    setConverToSalesDataList(item);
    setModifyconverToSales(true);
  };

  const handleConvertToSaleClose = () => {
    setModifyconverToSales(false);
    setConverToSalesData({
      reservation_id: "",
      warehouses_id: "",
      seller_id: "",
      sales_type: 1,
      sales_notes: "",
      client_id: "",
      shipping_price: "",
      packing_price: "",
      parcel_price: "",
    });
  };

  const handleAddModal = (item) => {
    setclientProfileData({
      uuid: item?.uuid,
      id: item?.id,
      name: item?.name,
      district: item?.state_name,
      city: item?.city_name,
      bill_address: item?.bill_address,
      postal_code: item?.postal_code,
      shipping_addresses: item?.shipping_addresses,
      vat_country_code: item?.vat_country_code,
      vat_number: item?.vat_number,
      vat_percentage: item?.vat_percentage,
      is_vat_exempt: item?.is_vat_exempt,
      indicative_phone_code: item?.indicative_phone_code,
      phone_number: item?.phone_number,
      whatsapp_number: item?.whatsapp_number,
      email: item?.email,
      country_code: item?.country_code,
    });

    setModifyClientModal(true);
  };

  const handleCloseModal = () => {
    setModifyClientModal(false);

    setclientProfileData({
      uuid: "",
      id: "",
      name: "",
      country_id: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
      country_code: "",
    });
  };

  const handleSaveDataModal = () => {
    setModifyClientModal(false);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    if (clientResDataDetails) {
      let data = {
        uuid: clientResDataDetails?.uuid,
      };
      getReservesDetails(data)
        .then((response) => {
          setReserveDetails(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [clientResDataDetails]);

  useEffect(() => {
    if (converToSalesDataList) {
      setConverToSalesData((prev) => ({
        ...prev,
        sales_notes: converToSalesDataList?.reservation_notes,
        client_id: converToSalesDataList?.client_id,
        shipping_price: converToSalesDataList?.shipping_price,
        packing_price: converToSalesDataList?.packing_price,
        parcel_price: converToSalesDataList?.parcel_price,
        warehouses_id: converToSalesDataList?.warehouses_id,
      }));
    }
  }, [converToSalesDataList]);

  useEffect(function () {
    const obj = {
      search: "",
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataMainList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    let data = { ...params };

    getParentWarhouseData(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.warehouse_name,
          });
        }
        setEntityList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };
    getSerachClientProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            fullData: response.data[i],
          });
        }

        setUserDataList(list);
      })
      .catch(() => {});
  }, []);

  const handleShowOpen = () => {
    setShow(true);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  const handleFileChangeImage = (event) => {
    const files = Array.from(event.target.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));

    if (imageFiles.length === 0) {
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...imageFiles]);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "reserve_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setStatusResList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = { ...params };
    getCompanyEcommerceHashList(data)
      .then((response) => {
        setCompanyEcommerceList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "refund_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setRefundTypeList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSelectChangeRefund = (selectedOption) => {
    setRefundData({
      ...refundData,
      refund_type: selectedOption ? selectedOption.value : "",
    });
  };

  const handleSelectChange = (selectedOption) => {
    setSalesData({
      ...salesData,
      order_status: selectedOption ? selectedOption.value : "",
    });
    if (selectedOption?.value === 1) {
      const formData = new FormData();
      formData.append("id", delpart.id);
      formData.append("order_status", 1);
      updateCompanySalesStatus(formData)
        .then((response) => {
          let data = { ...params };

          featchreservesList(data);
          toast.success(response.data.message);

          setStatusModal(false);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }

    if (selectedOption?.value === 2) {
      const formData = new FormData();
      formData.append("id", delpart.id);
      formData.append("order_status", 2);
      updateCompanySalesStatus(formData)
        .then((response) => {
          let data = { ...params };

          featchreservesList(data);
          toast.success(response.data.message);
          setStatusModal(false);
          setIsDelButtonLoad(false);
          setModifyAcceptedModal(true);
          setDelModal(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }

    if (selectedOption?.value === 3) {
      setModifyAcceptedModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 4) {
      setModifyCancelModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 5) {
      setModifyRefundModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 6) {
      setModifyCancelModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 7) {
      setModifyCancelModal(true);
      setDelModal(false);
    }
  };

  const handleAddAccpetedStatusSubmit = (e) => {
    e.preventDefault();

    if (selectedRadio === "1") {
      const formData = new FormData();
      formData.append("id", delpart.id);
      formData.append("order_status", 3);
      if (delpart?.seller_takes_care_shipping === true) {
        formData.append("shipping_label", selectedFile);
        formData.append("shipping_company", failedData.shipping_company);
        formData.append(
          "shipping_tracking_code",
          failedData.shipping_tracking_code,
        );
      }

      selectedFiles.forEach((file) => {
        formData.append("order_images", file);
      });
      updateCompanySalesStatus(formData)
        .then((response) => {
          let data = { ...params };

          featchreservesList(data);
          toast.success(response.data.message);
          setDelPart("");
          setModifyAcceptedModal(false);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
      setModifyAcceptedModal(true);
      setDelModal(false);
    }

    if (selectedRadio === "2") {
      let error = false;
      let errorObj = { ...errorsObj };
      if (!failedData.reason_failed_sale) {
        errorObj.reason_failed_sale = `Reason is required.`;
        error = true;
      }

      setErrors(errorObj);
      Utils.focusError();

      const formData = new FormData();
      formData.append("id", delpart.id);
      formData.append("order_status", 4);
      formData.append("reason_failed_sale", failedData.reason_failed_sale);

      selectedFiles.forEach((file) => {
        formData.append("images[]", file);
      });
      updateCompanySalesStatus(formData)
        .then((response) => {
          let data = { ...params };

          featchreservesList(data);
          toast.success(response.data.message);
          setDelPart("");
          setModifyAcceptedModal(false);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
      setModifyAcceptedModal(true);
      setDelModal(false);
    }
  };

  const handleAddCancelStatusSubmit = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };
    if (!failedData.reason_failed_sale) {
      errorObj.reason_failed_sale = `Reason is required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;
    const formData = new FormData();
    formData.append("id", delpart.id);
    formData.append("order_status", salesData?.order_status);
    formData.append("reason_failed_sale", failedData.reason_failed_sale);

    updateCompanySalesStatus(formData)
      .then((response) => {
        let data = { ...params };

        featchreservesList(data);
        toast.success(response.data.message);
        setDelPart("");
        setModifyCancelModal(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
    setModifyCancelModal(true);
    setDelModal(false);
  };

  const handleAddRefundStatusSubmit = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };

    if (refundData?.refund_type === 2) {
      if (!refundData.refund_value) {
        errorObj.refund_value = `Refund value is required.`;
        error = true;
      }
    }

    if (!refundData.refund_type) {
      errorObj.refund_type = `Refund type is required.`;
      error = true;
    }

    if (!refundData.refund_reason) {
      errorObj.refund_reason = `Reason is required.`;
      error = true;
    }

    setErrorsRefund(errorObj);
    Utils.focusError();

    if (error) return;
    const formData = new FormData();
    formData.append("id", delpart.id);
    formData.append("order_status", 5);
    formData.append("refund_type", refundData.refund_type);
    formData.append("refund_reason", refundData.refund_reason);
    formData.append("refund_value", refundData.refundData || 0);

    updateCompanySalesStatus(formData)
      .then((response) => {
        let data = { ...params };

        featchreservesList(data);
        toast.success(response.data.message);
        setDelPart("");
        setModifyRefundModal(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
    setModifyRefundModal(true);
    setDelModal(false);
  };

  useEffect(() => {
    if (delpart) {
      setSalesData((prevSalesData) => ({
        ...prevSalesData, // Keep previous values
        order_status: delpart?.order_status, // Update only order_status
      }));
    }
  }, [delpart]);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("filterData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname, params?.page]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }

    paramsObj.reservation_status = clientFilterData?.reservation_status;
    paramsObj.warehouse_id = clientFilterData?.warehouse_id;
    paramsObj.search_client = clientFilterData?.search_client;

    localStorage.setItem("filterData", JSON.stringify(paramsObj));
    setParams(paramsObj);
    setShow(false);
  };

  useEffect(() => {
    const savedFilterData = localStorage.getItem("filterData");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);

      setParams(parsedFilterData);
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterData"));
    if (savedData) {
      setClientFilterData({
        reservation_status: savedData?.reservation_status,
        search_client: savedData?.search_client,
        warehouse_id: savedData?.warehouse_id,
      });
    }
  }, []);

  const ResetModal = () => {
    setParams({
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      reservation_status: 1,
      warehouse_id: "",
      search_client: "",
    });
    setClientFilterData({
      reservation_status: "",
      search_client: "",
      warehouse_id: "",
    });
    setShow(false);
    localStorage.removeItem("filterData");
  };

  const featchreservesList = () => {
    let data = { ...params };
    getMainReservesList(data)
      .then((response) => {
        setReservesList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      featchreservesList(data);
    },
    [params],
  );

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onViewSales = (e, item) => {
    setModifyModal(true);
    setSalesViewData(item);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item);
    setDelModal(true);
  };

  const handleCheckboxChange = (e) => {
    setclientProfileData({
      ...clientProfileData,
      is_vat_exempt: e.target.checked ? 1 : 0,
    });
  };

  const handleAddressChange = (index, value) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses[index] = value;
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddress = () => {
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: [...clientProfileData.shipping_addresses, ""],
    });
  };

  const handleRemoveAddress = (index) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses.splice(index, 1);
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const onCancelRes = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { uuid: delpart };
    cancelReservesData(data)
      .then((response) => {
        let data = { ...params };

        featchreservesList(data);
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const hanldeConvertToSales = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = {
      reservation_id: converToSalesDataList?.id,
      warehouses_id: converToSalesData?.warehouses_id,
      seller_id: converToSalesData?.seller_id,
      sales_type: converToSalesData?.sales_type,
      sales_notes: converToSalesData?.sales_notes,
      shipping_price: converToSalesData?.shipping_price,
      packing_price: converToSalesData?.packing_price,
      parcel_price: converToSalesData?.parcel_price,
      client_id: converToSalesData?.client_id,
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: clientProfileData?.vat_percentage,
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
      expiration_date: converToSalesData?.expiration_date,
      document_set_id: converToSalesData?.document_set_id,
    };
    AddReservesConvertToSales(data)
      .then((response) => {
        let data = { ...params };

        featchreservesList(data);
        toast.success(response.data.message);
        setDelPart("");
        setModifyconverToSales(false);
        setIsDelButtonLoad(false);
        setConverToSalesData({
          reservation_id: "",
          warehouses_id: "",
          seller_id: "",
          sales_type: 1,
          sales_notes: "",
          client_id: "",
          shipping_price: "",
          packing_price: "",
          parcel_price: "",
        });
        navigate("/internal-sales");
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    if (userDataList && converToSalesData?.client_id) {
      const foundClient = userDataList.find(
        (item) => item.value == converToSalesData.client_id,
      )?.fullData;
      setclientProfileData({
        uuid: foundClient?.uuid,
        id: foundClient?.id,
        name: foundClient?.name,
        district: foundClient?.state_name,
        city: foundClient?.city_name,
        bill_address: foundClient?.bill_address,
        postal_code: foundClient?.postal_code,
        shipping_addresses: foundClient?.shipping_addresses,
        vat_country_code: foundClient?.vat_country_code,
        vat_number: foundClient?.vat_number,
        vat_percentage: foundClient?.vat_percentage,
        is_vat_exempt: foundClient?.is_vat_exempt,
        indicative_phone_code: foundClient?.indicative_phone_code,
        phone_number: foundClient?.phone_number,
        whatsapp_number: foundClient?.whatsapp_number,
        email: foundClient?.email,
        country_code: foundClient?.country_code,
      });
    }
  }, [userDataList, converToSalesData?.client_id]);

  useEffect(() => {
    if (converToSalesDataList) {
      setclientProfileData({
        uuid: "",
        id: "",
        name: converToSalesDataList?.client_name || "",

        district: converToSalesDataList?.client_district || "",
        city: converToSalesDataList?.client_city || "",
        bill_address: converToSalesDataList?.client_bill_address || "",
        postal_code: converToSalesDataList?.client_postal_code || "",
        shipping_addresses: Array.isArray(
          converToSalesDataList?.client_shipping_addresses,
        )
          ? converToSalesDataList.client_shipping_addresses
          : [],
        vat_country_code: converToSalesDataList?.client_vat_country_code || "",
        vat_number: converToSalesDataList?.client_vat_number || "",
        vat_percentage: converToSalesDataList?.client_vat_percentage || "",
        is_vat_exempt: converToSalesDataList?.client_is_vat_exempt || "0",
        indicative_phone_code:
          converToSalesDataList?.client_indicative_phone_code || "",
        phone_number: converToSalesDataList?.client_phone_number || "",
        whatsapp_number: converToSalesDataList?.client_phone_number || "",
        email: converToSalesDataList?.client_email || "",
        country_code: converToSalesDataList?.client_country_code || "",
      });
    }
  }, [converToSalesDataList]);

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left fuelCT"
                      style={{ width: "60%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder={t("search")}
                      ></input>
                    </div>

                    {show && (
                      <div
                        className="offcanvas-backdrop show"
                        onClick={(e) => e.stopPropagation()}
                      ></div>
                    )}

                    <div className="card-title m-0 float-right rightBtn">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={() => navigate("/add-reserves")}
                      >
                        <i className="bi bi-geo-alt-fill"></i>
                        <span className="ms-2">Add Reserves</span>
                      </button>

                      <button
                        type="button"
                        className="btn-icon-text mr-2 mr-2"
                        onClick={handleShowOpen}
                      >
                        <i className="bi bi-funnel"></i>
                        {t("filter")}
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive-reserve table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("reservation_name")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("client_name")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("packing_price")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("parcel_price")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("shipping_price")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("total_price")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("reservation_end_date")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("reservation_status")}{" "}
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              {t("action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reservesList?.map((item, index) => {
                            return (
                              <>
                                <tr key={item.id}>
                                  {" "}
                                  <td>{item?.reservation_name}</td>
                                  <td>{item?.client_name}</td>
                                  <td>{item?.packing_price || 0} €</td>
                                  <td>{item?.parcel_price || 0} €</td>
                                  <td>{item?.shipping_price || 0} €</td>
                                  <td>{item?.total_price || 0} €</td>
                                  <td>
                                    {item?.reservation_end_date
                                      ? moment(
                                          item?.reservation_end_date,
                                        ).format("DD/MM/YYYY")
                                      : "-"}
                                  </td>
                                  <td>
                                    <td>
                                      <span
                                        className={
                                          statusMap[item?.reservation_status]
                                            ?.className || "badge bg-secondary"
                                        }
                                      >
                                        {statusMap[item?.reservation_status]
                                          ?.label || ""}
                                      </span>
                                    </td>
                                  </td>
                                  <td>
                                    <div className="d-flex">
                                      <Dropdown
                                        className="iconDropdown"
                                        onToggle={(isOpen) => {
                                          if (isOpen) {
                                            // This logic runs when the dropdown is opened
                                            const tableResponsive =
                                              document.querySelector(
                                                ".table-responsive-reserve",
                                              );
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "inherit !important";
                                              tableResponsive.style.overflowY =
                                                "inherit !important";
                                            }
                                          }
                                        }}
                                      >
                                        <Dropdown.Toggle
                                          variant="success"
                                          id="dropdown-basic"
                                          className="iconToggle"
                                        >
                                          <i className="bi bi-three-dots-vertical"></i>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {item?.reservation_status !== 2 && (
                                            <Dropdown.Item
                                              className="d-flex"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                if (item) {
                                                  navigate(
                                                    `/add-reserves/${item.uuid}`,
                                                    {
                                                      state: item,
                                                    },
                                                  );
                                                }
                                              }}
                                            >
                                              <button
                                                className="edit-btn"
                                                onClick={(e) =>
                                                  e.preventDefault()
                                                }
                                              >
                                                <i className="bi bi-pencil"></i>
                                              </button>
                                              <span>{t("edit")}</span>
                                            </Dropdown.Item>
                                          )}
                                          
                                          {item?.reservation_status === 1 && (
                                            <Dropdown.Item
                                              className="d-flex"
                                              onClick={(e) =>
                                                handleConvertToSaleOpen(e, item)
                                              }
                                            >
                                              <button
                                                className="edit-btn"
                                                onClick={(e) =>
                                                  e.preventDefault()
                                                }
                                              >
                                                <i className="bi bi-receipt"></i>{" "}
                                              </button>
                                              <span className="ms-2">
                                                Converted Into Sales
                                              </span>
                                            </Dropdown.Item>
                                          )}

                                          <Dropdown.Item
                                            className="d-flex"
                                            onClick={(e) =>
                                              handleClientDetailsOpen(e, item)
                                            }
                                          >
                                            <button className="edit-btn">
                                              <i className="bi bi-pencil"></i>
                                            </button>
                                            <span>{t("details")}</span>
                                          </Dropdown.Item>

                                          {item?.reservation_status !== 2 && (
                                            <Dropdown.Item
                                              className="d-flex"
                                              onClick={(e) =>
                                                onDeleteModalOpen(e, item.uuid)
                                              }
                                            >
                                              <div className="trash-btn delete-btn">
                                                <i className="bi bi-trash3"></i>
                                              </div>

                                              <span>Cancelled</span>
                                            </Dropdown.Item>
                                          )}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                          {reservesList && reservesList.length === 0 && (
                            <tr>
                              <td colSpan={4} className="text-center">
                                Record Not Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-footer-part clearfix">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{`Cancel Reserves`}</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Are you sure you want to cancel this reserves?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onCancelRes}
            >{t("cancel")}<i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyconverToSales} size="xl">
        <ModalHeader>{t("converted_to_sales")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <div className="Label-my">
                Sales Type{" "}
                <Select
                  className="my-select-v"
                  options={covertSalesList}
                  value={covertSalesList.find(
                    (item) => item.value == converToSalesData.sales_type,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      sales_type: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Sales Type"}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Seller{" "}
                <Select
                  className="my-select-v"
                  options={userDataMainList}
                  value={userDataMainList.find(
                    (item) => item.value == converToSalesData.seller_id,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      seller_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Seller"}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  Select Client
                  <span
                    style={{
                      marginLeft: "155px",
                      fontSize: "20px",
                      color: "#81bb42",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const selectedClient = userDataList.find(
                        (item) => item.value == converToSalesData.client_id,
                      )?.fullData;

                      if (selectedClient) {
                        handleAddModal(selectedClient);
                      } else {
                        const fallbackData = {
                          uuid: "",
                          id: "",
                          name: converToSalesDataList?.client_name || "",

                          district:
                            converToSalesDataList?.client_district || "",
                          city: converToSalesDataList?.client_city || "",
                          bill_address:
                            converToSalesDataList?.client_bill_address || "",
                          postal_code:
                            converToSalesDataList?.client_postal_code || "",
                          shipping_addresses: Array.isArray(
                            converToSalesDataList?.client_shipping_addresses,
                          )
                            ? converToSalesDataList.client_shipping_addresses
                            : [],
                          vat_country_code:
                            converToSalesDataList?.client_vat_country_code ||
                            "",
                          vat_number:
                            converToSalesDataList?.client_vat_number || "",
                          vat_percentage:
                            converToSalesDataList?.client_vat_percentage || "",
                          is_vat_exempt:
                            converToSalesDataList?.client_is_vat_exempt || "0",
                          indicative_phone_code:
                            converToSalesDataList?.client_indicative_phone_code ||
                            "",
                          phone_number:
                            converToSalesDataList?.client_phone_number || "",
                          whatsapp_number:
                            converToSalesDataList?.client_phone_number || "",
                          email: converToSalesDataList?.client_email || "",
                          country_code:
                            converToSalesDataList?.client_country_code || "",
                        };

                        setclientProfileData(fallbackData);
                        handleAddModal(fallbackData);
                      }
                    }}
                  >
                    <i className="bi bi-info-circle-fill"></i>
                  </span>
                </Label>
                <Select
                  className="my-select-v"
                  options={userDataList}
                  value={userDataList.find(
                    (item) => item.value == converToSalesData.client_id,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      client_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Client"}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                WareHouse{" "}
                <Select
                  className="my-select-v"
                  options={entityList}
                  value={entityList.find(
                    (item) => item.value == converToSalesData.warehouses_id,
                  )}
                  onChange={(selectedOption) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      warehouses_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select WareHouse"}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Sales Notes{" "}
                <textarea
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.sales_notes}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      sales_notes: e.target.value,
                    });
                  }}
                  name="sales_notes"
                  placeholder={t("sales_notes")}
                  rows={3}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Parcel Price{" "}
                <input
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.parcel_price}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      parcel_price: e.target.value,
                    });
                  }}
                  name="parcel_price"
                  placeholder={t("parcel_price")}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Packing Price{" "}
                <input
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.packing_price}
                  name="packing_price"
                  placeholder={t("packing_price")}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      packing_price: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my">
                Shipping Price{" "}
                <input
                  type="text"
                  className="form-control input-search"
                  value={converToSalesData.shipping_price}
                  name="shipping_price"
                  placeholder={t("shipping_price")}
                  onChange={(e) => {
                    setConverToSalesData({
                      ...converToSalesData,
                      shipping_price: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-md-6"></div>

            <div className="row">
              <div className="Label-my">Part Details</div>
              <div className="col-md-12">
                <div
                  className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                  style={{
                    height: "186px",
                    minHeight: "245px",
                  }}
                >
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th style={{}}>Part Name</th>
                        <th style={{}}>Reserve Price</th>
                      </tr>
                    </thead>

                    <tbody>
                      {converToSalesDataList?.part_list?.length > 0 ? (
                        converToSalesDataList?.part_list?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.namePartPT}</td>
                            <td>{item.reserve_price}</td>
                          </tr>
                        ))
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {Number(settingCompanyDetails?.is_all_sync) === 1 && (
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("expirationDate")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={converToSalesData.expiration_date}
                            onChange={(e) => {
                              setConverToSalesData({
                                ...converToSalesData,
                                expiration_date: e.target.value,
                              });
                            }}
                            name="expiration_date"
                            placeholder={t("expiration_date")}
                          />
                        </div>
                        {/* {errors.expiration_date && (
                          <span className="input-error">
                            {errors.expiration_date}
                          </span>
                        )} */}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("documentSet")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={documentSetList}
                            value={documentSetList.find(
                              (item) =>
                                item.value ===
                                converToSalesData.document_set_id,
                            )}
                            onChange={(selectedOption) => {
                              setConverToSalesData({
                                ...converToSalesData,
                                document_set_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Document Set"}
                          />
                          {/* {errors.document_set_id && (
                            <span className="input-error">
                              {errors.document_set_id}
                            </span>
                          )} */}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4" />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={handleConvertToSaleClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              onClick={hanldeConvertToSales}
            >{t("yes")}<i className="bi bi-x-lg"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <div
        className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
        tabIndex="-1"
        id="staticBackdrop"
        aria-labelledby="staticBackdropLabel"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="staticBackdropLabel">
            {t("filter")}
          </h5>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleShowClose}
          ></button>
        </div>

        <div className="offcanvas-body">
          <div>
            <div href="#/action-2">
              <div className="Label-my">
                Warehouse{" "}
                <Select
                  className="my-select-v"
                  options={entityList}
                  value={
                    entityList.find(
                      (item) => item.value == clientFilterData.warehouse_id,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      warehouse_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Warehouse"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Client{" "}
                {/* <Select
                  className="my-select-v"
                  options={userDataList}
                  value={
                    userDataList.find(
                      (item) => item.value == clientFilterData.search_client
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      search_client: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Client"}
                /> */}
                <input
                  type="text"
                  className="form-control"
                  value={clientFilterData.search_client}
                  onChange={(e) =>
                    setClientFilterData({
                      ...clientFilterData,
                      search_client: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Status{" "}
                <Select
                  className="my-select-v"
                  options={statusResList}
                  value={
                    statusResList.find(
                      (item) =>
                        item.value == clientFilterData.reservation_status,
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setClientFilterData({
                      ...clientFilterData,
                      reservation_status: selectedOption
                        ? selectedOption.value
                        : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Status"}
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-around mb-3">
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary btn-filter"
              onClick={(e) => handleParams(e, "search")}
            >
              <span className="ms-1">{t("filter")}</span>
            </button>
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary ms-1 btn-filter"
              onClick={ResetModal}
            >
              <span className="ms-1 ">Reset</span>
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={modifyClientModal} size="lg">
        <ModalHeader>Client Profile</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">{"Name"}</Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.name}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          name: e.target.value,
                        });
                      }}
                      name={`name`}
                      maxLength={50}
                      placeholder={t("name")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Country Code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.country_code}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          country_code: e.target.value,
                        });
                      }}
                      name={`country_code`}
                      maxLength={50}
                      placeholder={t("country_code")}
                    />
                    {errors.country_code && (
                      <span className="input-error">{errors.country_code}</span>
                    )}
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"State"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.district}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          district: e.target.value,
                        });
                      }}
                      name={`district`}
                      maxLength={50}
                      placeholder={t("district")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {t("city")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.city}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          city: e.target.value,
                        });
                      }}
                      name={`city`}
                      maxLength={50}
                      placeholder={t("city")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Bill Address"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.bill_address}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          bill_address: e.target.value,
                        });
                      }}
                      name={`bill_address`}
                      maxLength={50}
                      placeholder={t("bill_address")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Postal code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.postal_code}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          postal_code: e.target.value,
                        });
                      }}
                      name={`postal_code`}
                      maxLength={50}
                      placeholder={t("postal_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"VAT country code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.vat_country_code}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          vat_country_code: e.target.value,
                        });
                      }}
                      name={`vat_country_code`}
                      maxLength={50}
                      placeholder={t("vat_country_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"VAT number"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.vat_number}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          vat_number: e.target.value,
                        });
                      }}
                      name={`vat_number`}
                      maxLength={50}
                      placeholder={t("vat_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"VAT Percentages(%)"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.vat_percentage ?? 23}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          vat_percentage: e.target.value,
                        });
                      }}
                      name="vat_percentage"
                      maxLength={50}
                      placeholder={t("vat_percentages")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  Is VAT exempt{" "}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={clientProfileData?.is_vat_exempt === 1}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label">VAT exempt </label>
                    </div>
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Indicative phone code"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.indicative_phone_code || "+351"}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          indicative_phone_code: e.target.value,
                        });
                      }}
                      name={`indicative_phone_code`}
                      maxLength={50}
                      placeholder={t("indicative_phone_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Phone Number"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.phone_number}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          phone_number: e.target.value,
                        });
                      }}
                      name={`phone_number`}
                      maxLength={50}
                      placeholder={t("phone_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Whatsapp Number"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.whatsapp_number}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          whatsapp_number: e.target.value,
                        });
                      }}
                      name={`whatsapp_number`}
                      maxLength={50}
                      placeholder={t("whatsapp_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"Email"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientProfileData.email}
                      onChange={(e) => {
                        setclientProfileData({
                          ...clientProfileData,
                          email: e.target.value,
                        });
                      }}
                      name={`email`}
                      maxLength={50}
                      placeholder={t("email")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4"></div>

            <div className="col-md-12">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  Shipping Address
                </Label>
                <div className="col-xl-12">
                  {clientProfileData?.shipping_addresses?.map(
                    (address, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center mb-2"
                      >
                        <input
                          type="text"
                          className="form-control input-search mr-2"
                          placeholder={`Shipping address ${index + 1}`}
                          value={address}
                          onChange={(e) =>
                            handleAddressChange(index, e.target.value)
                          } // Update address
                        />
                        <i
                          className="bi bi-x-circle"
                          style={{
                            marginTop: "-41px",
                            marginLeft: "-16px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemoveAddress(index)} // Remove address
                        ></i>
                      </div>
                    ),
                  )}

                  <button
                    type="button"
                    className="btn btn-primary btn-sm mt-2"
                    onClick={handleAddAddress} // Add address
                  >
                    ➕ Add Address
                  </button>
                </div>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isModifyButtonLoad}
            onClick={handleCloseModal}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
          {!isModifyButtonLoad && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px", marginTop: "10px" }}
              onClick={handleSaveDataModal}
            >{t("save")}<i className="bi bi-check2"></i>
            </button>
          )}
          {isModifyButtonLoad && (
            <Button
              color="success"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyClientDetailsModal} size="xl">
        <ModalHeader className="modal-custom-header">
          {"Reserve Details"}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div
                className="row sales-detail-row"
                style={{
                  marginTop: "10px",
                }}
              >
                <div className="col-md-4 col-sales">
                  Reservation Name :{reserveDetails?.reservation_name || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Packing Price :€ {reserveDetails?.packing_price || "-"}
                </div>
                <div className="col-md-4 col-sales">
                  Parcel Price : € {reserveDetails?.parcel_price || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Notes :{reserveDetails?.reservation_notes || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Reservation End Date:
                  {reserveDetails?.reservation_end_date
                    ? moment(reserveDetails.reservation_end_date).format(
                        "YYYY-MM-DD HH:mm",
                      )
                    : "-"}{" "}
                </div>

                <div className="col-md-4 col-sales">
                  Total Price :€ {reserveDetails?.total_price || "-"}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="Label-my mb-2 mt-2">Client Details</div>
            </div>
            <div className="col-md-12">
              <div
                className="row sales-detail-row"
                style={{
                  marginTop: "10px",
                }}
              >
                <div className="col-md-4 col-sales">
                  Client Name :{reserveDetails?.client_name || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Email: {reserveDetails?.client_email || "-"}
                </div>
                <div className="col-md-4 col-sales">
                  Country Code :{reserveDetails?.client_country_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  District : {reserveDetails?.client_district || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  City : {reserveDetails?.client_city || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Bill Address :{reserveDetails?.client_bill_address || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Postal Code : {reserveDetails?.client_postal_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Country Code:{" "}
                  {reserveDetails?.client_vat_country_code || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Number: {reserveDetails?.client_vat_number || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Percentage(%):{" "}
                  {reserveDetails?.client_vat_percentage || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  VAT Exempt:{" "}
                  {reserveDetails?.client_is_vat_exempt === "1"
                    ? "Yes"
                    : "NO" || "-"}
                </div>

                <div className="col-md-4 col-sales">
                  Indicative Phone Code:{" "}
                  {reserveDetails?.client_indicative_phone_code}
                </div>

                <div className="col-md-4 col-sales">
                  Phone Code: {reserveDetails?.client_phone_number}
                </div>

                <div className="col-md-4 col-sales">
                  Whatsapp Number: {reserveDetails?.client_whatsapp_number}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="Label-my mb-2 mt-2">Shipping Address</div>
              <div
                className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                style={{
                  height: "150px",
                  minHeight: "150px",
                }}
              >
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                    </tr>
                  </thead>

                  <tbody>
                    {reserveDetails?.client_shipping_addresses?.length > 0 ? (
                      reserveDetails?.client_shipping_addresses?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item}</td>
                          </tr>
                        ),
                      )
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-md-6">
              <div className="Label-my mb-2 mt-2">Part Details</div>
              <div
                className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                style={{
                  height: "150px",
                  minHeight: "150px",
                }}
              >
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Part Name</th>
                      <th>Warehouse name</th>
                      <th>Sales Order Notes</th>
                      <th>Price</th>

                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {reserveDetails?.part_list?.length > 0 ? (
                      reserveDetails?.part_list?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.namePartPT}</td>
                          <td>{item?.warehouse_name}</td>
                          <td>{item?.reservation_order_notes}</td>
                          <td>€ {item?.reserve_price}</td>

                          <td style={{ cursor: "pointer" }}>
                            <i
                              className="bi bi-eye-fill"
                              onClick={(e) => {
                                e.preventDefault();
                                if (item) {
                                  navigate(
                                    `/part/details/inven/${item.parts_id}`,
                                    {
                                      state: item,
                                    },
                                  );
                                }
                              }}
                            ></i>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">No results found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleClientDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ReservesList;
